/* eslint-disable no-param-reassign */
import type { Module } from 'vuex';
import { ToastType, PayType, VisiblePage } from '@/common';
import type { DeferRootState, CashierState, PromoInfoType } from '../constants';
import { actions as displayConsultActions } from './displayconsult-actions';
import { actions as paydelayActions } from './paydelay-actions';

export function getPayDelayModule(): Module<CashierState, DeferRootState> {
  return {
    namespaced: true,

    state: {
      displayConsultData: {} as DisplayConsultDataType,
      toastData: {
        show: false,
        toastType: ToastType.Error,
        toastText: '',
        toastSubText: '',
        payType: PayType.PayDelay,
      } as ToastStatusAndType,
      // 控制签约半页的其他按钮是否能点击
      btnPending: false,
      marketInfoData: {} as MarketInfoType,
      // 控制签约半页的支付按钮是否能点击
      payBtnLoading: false,
      promoInfo: {} as PromoInfoType,
      // 独立开通数据
      /** 是否展示半页 */
      showHalfPage: false,
      promoDetails: '',
      halfPageSwitchEmun: VisiblePage.index,
    },
    mutations: {
      setDisplayConsultData(state, payload: { displayConsultData: DisplayConsultDataType }): void {
        state.displayConsultData = payload.displayConsultData;
      },
      setToast(
        state,
        payload: { show: boolean; toastType: string; toastText: string; toastSubText: string; payType: string }
      ): void {
        state.toastData.show = payload.show;
        state.toastData.toastType = payload.toastType || ToastType.Error;
        state.toastData.toastText = payload.toastText || '';
        state.toastData.toastSubText = payload.toastSubText || '';
        state.toastData.payType = payload.payType || PayType.PayDelay;
      },
      setBtnPending(state, payload: { btnPending: boolean }): void {
        state.btnPending = payload.btnPending;
      },
      setPayBtnLoading(state, payload: { payBtnLoading: boolean }): void {
        state.payBtnLoading = payload.payBtnLoading;
      },
      setMarketInfo(state, payload: { openPageData: ShowDataType }) {
        // 气泡文案为空，不传营销信息给后端
        if (payload.openPageData?.promoLabel) {
          state.marketInfoData = {
            bubbleText: payload.openPageData?.promoLabel,
            delaypay_open_promo_info: payload.openPageData?.promoDetails || '',
          };
        }
      },
      // 支付中签约和独立签约先用后付营销页面展示
      setPromoInfo(state, payload: { promoInfo: PromoInfoType }) {
        state.promoInfo = {
          ...state.promoInfo,
          ...payload.promoInfo,
        };
      },
      // 独立签约数据
      setShowHalfPage(state, payload: { showHalfPage: boolean }): void {
        state.showHalfPage = payload.showHalfPage;
      },
      setPromoDetails(state, payload: { promoDetails: string }) {
        state.promoDetails = payload.promoDetails;
      },
      setHalfPageSwitchEmun(state, payload: { halfPageSwitchEmun: VisiblePage; height: number }) {
        if (state.payBtnLoading) {
          return;
        }
        state.halfPageSwitchEmun = payload.halfPageSwitchEmun;
      },
    },
    actions: {
      ...displayConsultActions,
      ...paydelayActions,
    },
  };
}
